import React from 'react';

import {
  Box,
  Snackbar,
  styled
} from '@mui/material';



const ContainerBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  background: '#486C82',
  borderRadius: 10,
  padding: theme.spacing(1)
}));



export interface IProps {
  children?: React.ReactNode | React.ReactNode[];

  onClose: () => void;
}

export const FC: React.FC<IProps> = props => {
  return (
    <Snackbar
      open
      autoHideDuration={5000}
      onClose={props.onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right'
      }}>
      <ContainerBox>
        {props.children}
      </ContainerBox>
    </Snackbar>
  );
};
